module.exports = __webpack_public_path__ + "img/r-green.6dd3bc41.svg";